import type { FC, ReactNode } from 'react'

import Reveal from '@/components/generals/reveal'
import { PRESENCE_STATS } from '@/constants/landing'

const PresenceStrip: FC = (): ReactNode => {
    return (
        <section id='presence' aria-labelledby='presence-title' className='bg-background'>
            <div className='mx-auto max-w-[1440px] px-5 pb-16 pt-20 md:px-8 md:pb-20 md:pt-28'>
                <div className='grid gap-8 lg:grid-cols-12 lg:gap-10'>
                    <Reveal className='lg:col-span-7'>
                        <p className='font-mono text-[11px] uppercase tracking-[0.18em] text-ember-deep'>
                            Made for the home you already have
                        </p>

                        <h2 id='presence-title' className='mt-5 font-heading text-[clamp(2.6rem,5.4vw,5rem)] leading-[0.96] tracking-[-0.02em] text-foreground'>
                            No rails, no rewiring, <em className='italic text-ember-deep'>no special rooms.</em>
                        </h2>
                    </Reveal>

                    <Reveal delay={150} className='flex flex-col justify-end lg:col-span-5'>
                        <p className='max-w-md text-lg leading-relaxed text-muted-foreground'>
                            Oriel takes the stairs, opens doors and fits through any standard doorway. When its battery runs low, it finishes what it's doing and walks itself back to its dock.
                        </p>
                    </Reveal>
                </div>

                <dl className='mt-14 grid grid-cols-2 border-t border-border md:mt-20 lg:grid-cols-4'>
                    {PRESENCE_STATS.map((stat, index) => (
                        <Reveal
                            key={stat.label}
                            delay={index * 90}
                            className='border-b border-border py-7 pr-4 odd:border-r odd:pr-6 lg:border-b-0 lg:border-r lg:px-8 lg:first:pl-0 lg:last:border-r-0'
                        >
                            <dt className='sr-only'>
                                {stat.label}
                            </dt>

                            <dd>
                                <span className='flex items-baseline gap-1.5'>
                                    <span className='font-heading text-[clamp(3rem,5vw,4.5rem)] leading-none tracking-tight text-foreground'>
                                        {stat.value}
                                    </span>

                                    <span className='font-mono text-sm text-muted-foreground'>
                                        {stat.unit}
                                    </span>
                                </span>

                                <span aria-hidden='true' className='mt-3 block max-w-[15rem] text-[15px] leading-snug text-muted-foreground'>
                                    {stat.label}
                                </span>
                            </dd>
                        </Reveal>
                    ))}
                </dl>
            </div>
        </section>
    )
}

export default PresenceStrip
